import { connectedStore } from '../../store';

const isFolderNameDuplicated = (folderName, locale) => {
  const store = connectedStore.get();
  const state = store.getState();
  const { folders } = state.ws.site.meta;

  return folders.some((folder) => folder.name === folderName && folder.locale === locale) || false;
};

export default isFolderNameDuplicated;
